<!-- Completed: tinted card with the done tick, never linked -->
<div
  class="sc-action-card sc-action-done d-flex align-items-center justify-content-between"
  *ngIf="action().ActionCompleted; else todoRow"
>
  <div class="sc-action-main d-flex align-items-center">
    <div class="sc-action-icon sc-action-icon-done flex-shrink-0 d-flex align-items-center justify-content-center">
      <img [src]="action().Image | contentImage: '6'" alt="" class="sc-action-img" />
    </div>
    <p class="sc-action-name mb-0">{{ name() }}</p>
  </div>
  <span class="material-icons sc-done-icon flex-shrink-0">done</span>
</div>

<ng-template #todoRow>
  <ng-container [ngSwitch]="rowType()">
    <!-- Expand: only the header toggles the panel, which holds what is needed to complete the action -->
    <div *ngSwitchCase="'expand'" class="sc-action-card sc-action-todo sc-action-expandable" [class.is-expanded]="expanded()">
      <button
        type="button"
        class="sc-action-toggle d-flex align-items-center justify-content-between gap-3 w-100"
        [attr.aria-label]="name()"
        [attr.aria-expanded]="expanded()"
        [attr.aria-controls]="panelId"
        (click)="toggle()"
      >
        <ng-container *ngTemplateOutlet="todoContent"></ng-container>
        <!-- add and remove are stacked and crossfade with a quarter turn -->
        <span class="sc-action-toggle-icon flex-shrink-0" aria-hidden="true">
          <span class="material-icons sc-action-toggle-icon-add">add</span>
          <span class="material-icons sc-action-toggle-icon-remove">remove</span>
        </span>
      </button>

      <!-- Kept in the DOM so a typed code survives closing; inert and hidden from screen readers while closed -->
      <div
        [id]="panelId"
        class="sc-action-panel"
        [attr.inert]="expanded() ? null : ''"
        [attr.aria-hidden]="expanded() ? null : 'true'"
        (click)="$event.stopPropagation()"
      >
        <div class="sc-action-panel-inner">
          <div class="sc-action-panel-content">
            <ng-container [ngSwitch]="panel()">
              <ng-container *ngSwitchCase="'voucher'">
                <ng-container *ngTemplateOutlet="voucherPanel"></ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Link: the whole row opens the page where the action can be completed -->
    <button
      *ngSwitchCase="'link'"
      type="button"
      class="sc-action-card sc-action-todo sc-action-link d-flex align-items-center gap-3 w-100"
      [attr.aria-label]="name()"
      (click)="followLink()"
    >
      <ng-container *ngTemplateOutlet="todoContent"></ng-container>
      <span class="material-icons sc-action-arrow flex-shrink-0 ms-auto" aria-hidden="true">arrow_forward</span>
    </button>

    <!-- Plain: nothing to follow -->
    <div *ngSwitchDefault class="sc-action-card sc-action-todo d-flex align-items-center">
      <ng-container *ngTemplateOutlet="todoContent"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #todoContent>
  <div class="sc-action-main d-flex align-items-center">
    <div class="sc-action-icon sc-action-icon-todo flex-shrink-0 d-flex align-items-center justify-content-center">
      <img [src]="action().Image | contentImage: '6'" alt="" class="sc-action-img" />
    </div>
    <p class="sc-action-name mb-0">{{ name() }}</p>
  </div>
</ng-template>

<!-- Voucher: same service call and messages as the regular voucher component -->
<ng-template #voucherPanel>
  <div class="sc-voucher-card d-flex flex-column">
    <div class="sc-voucher-header d-flex align-items-center">
      <div class="sc-voucher-badge flex-shrink-0 d-flex align-items-center justify-content-center">
        <span class="material-icons" aria-hidden="true">redeem</span>
      </div>
      <div class="sc-voucher-info d-flex flex-column">
        <p class="sc-voucher-title mb-0">{{ 'fgbcl.challenges.voucher.title' | translate }}</p>
        <p class="sc-voucher-description mb-0">{{ 'fgbcl.challenges.voucher.description' | translate }}</p>
      </div>
    </div>

    <form class="sc-voucher-field d-flex align-items-center justify-content-between" (submit)="redeemVoucher($event)" novalidate>
      <label class="visually-hidden" [for]="voucherInputId">{{ 'fgbcl.challenges.voucher.input.screenreader' | translate }}</label>
      <input
        [id]="voucherInputId"
        type="text"
        class="sc-voucher-input"
        autocomplete="off"
        [value]="voucherCode()"
        [placeholder]="'fgbcl.challenges.voucher.placeholder' | translate"
        (input)="onVoucherInput($event)"
      />
      <button type="submit" class="sc-voucher-apply flex-shrink-0" [disabled]="voucherSubmitting() || !voucherCode().trim()">
        {{ 'voucher.apply' | translate }}
      </button>
    </form>

    <div class="sc-voucher-status" role="status" aria-live="polite">
      <div
        *ngIf="voucherMessage() as message"
        class="sc-voucher-message d-flex align-items-center"
        [ngClass]="'sc-voucher-message-' + message.type"
      >
        <span class="material-icons sc-voucher-message-icon" aria-hidden="true">{{
          message.type === 'success' ? 'check_circle' : 'cancel'
        }}</span>
        <span class="sc-voucher-message-text">{{ message.key | translate }}</span>
      </div>
    </div>
  </div>
</ng-template>
